import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "heading-title" }, "MFA", -1)
const _hoisted_2 = { id: "mfa-container" }
const _hoisted_3 = {
  key: 0,
  class: "credential-select-container"
}
const _hoisted_4 = ["value", "id"]
const _hoisted_5 = ["for"]
const _hoisted_6 = {
  key: 1,
  class: "code-submission-container"
}
const _hoisted_7 = { for: "mfa-code" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_ctx.step == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.credentials, (credential, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _withDirectives(_createElementVNode("input", {
                  class: "mfa-radio-input",
                  type: "radio",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCredentialID) = $event)),
                  value: credential.id,
                  id: credential.id?.toString()
                }, null, 8, _hoisted_4), [
                  [_vModelRadio, _ctx.selectedCredentialID]
                ]),
                _createElementVNode("label", {
                  for: credential.id?.toString()
                }, _toDisplayString(credential.question), 9, _hoisted_5)
              ]))
            }), 128)),
            _createElementVNode("div", null, [
              _createElementVNode("small", {
                class: _normalizeClass(["mfa-validation-message", {
            visible: _ctx.submitted && !_ctx.selectedCredentialID,
            invisible: !_ctx.submitted || _ctx.selectedCredentialID,
          }])
              }, "You must select an MFA option before continuing. ", 2),
              _createElementVNode("button", {
                class: "btn btn-primary w-100",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectCredential && _ctx.selectCredential(...args)))
              }, " Continue ")
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.instructions), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "mfa-code",
              class: "w-100",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mfaCode) = $event))
            }, null, 512), [
              [_vModelText, _ctx.mfaCode]
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("small", {
                class: _normalizeClass(["mfa-validation-message", {
            visible: _ctx.isSubmitValidationMessageVisible,
            invisible: !_ctx.isSubmitValidationMessageVisible,
          }])
              }, _toDisplayString(_ctx.submitValidationMessage ?? "N\\A"), 3),
              _createElementVNode("button", {
                class: "btn btn-primary w-100",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitMFACode && _ctx.submitMFACode(...args)))
              }, " Continue ")
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}